import React from "react";

const Footer = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <footer className="site-footer">
      <div>
        <span className="footer-name">{data.name}</span>
        <span className="footer-role">{data.occupation}</span>
      </div>
      <div className="footer-right">
        <div className="footer-social">
          {(data.social || []).map((network) => (
            <a
              key={network.name}
              href={network.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={network.name}
            >
              <i className={network.className} aria-hidden="true" />
            </a>
          ))}
        </div>
        <a className="back-to-top" href="#home">
          Back to top
        </a>
      </div>
    </footer>
  );
};

export default Footer;
